export default __webpack_public_path__ + "static/media/fish.fbe11031.png";